// Mock data para el frontend de MoraBioVet

export const estudios = [
  // HEMATOLOGÍA
  {
    id: '1',
    nombre: 'Hemograma Completo',
    descripcion: 'Análisis completo de células sanguíneas',
    precio: 155,
    tiempoEntrega: 'Mismo día',
    categoria: 'Hematología',
    preparacion: 'No requiere ayuno',
    urgente: true,
    precioUrgente: 245
  },
  {
    id: '2',
    nombre: 'Hemoparásitos (frotis)',
    descripcion: 'Detección de parásitos sanguíneos mediante frotis',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Hematología',
    preparacion: 'No requiere ayuno',
    urgente: false
  },
  {
    id: '3',
    nombre: 'Frotis Sanguíneo',
    descripcion: 'Interpretación de frotis sanguíneo',
    precio: 95,
    tiempoEntrega: 'Mismo día',
    categoria: 'Hematología',
    preparacion: 'No requiere ayuno',
    urgente: false
  },
  
  // BIOQUÍMICA CLÍNICA - Perfiles
  {
    id: '4',
    nombre: 'Perfil Completo',
    descripcion: '25-27 parámetros bioquímicos completos',
    precio: 645,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: true,
    precioUrgente: 895
  },
  {
    id: '5',
    nombre: 'Perfil Básico',
    descripcion: 'Parámetros bioquímicos esenciales',
    precio: 455,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: true,
    precioUrgente: 645
  },
  {
    id: '6',
    nombre: 'Perfil Prequirúrgico',
    descripcion: 'Evaluación preanestésica y quirúrgica',
    precio: 375,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: true,
    precioUrgente: 545
  },
  {
    id: '7',
    nombre: 'Perfil Renal',
    descripcion: 'Evaluación completa de función renal',
    precio: 415,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: true,
    precioUrgente: 595
  },
  {
    id: '8',
    nombre: 'Perfil Hepático',
    descripcion: 'Evaluación completa de función hepática',
    precio: 475,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: false
  },
  
  // BIOQUÍMICA - Analitos Individuales
  {
    id: '9',
    nombre: 'Glucosa',
    descripcion: 'Medición de glucosa en sangre',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  {
    id: '10',
    nombre: 'Urea',
    descripcion: 'Medición de urea sérica',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  {
    id: '11',
    nombre: 'Creatinina',
    descripcion: 'Medición de creatinina sérica',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  {
    id: '12',
    nombre: 'ALT (Alanina Aminotransferasa)',
    descripcion: 'Enzima hepática ALT',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  {
    id: '13',
    nombre: 'AST (Aspartato Aminotransferasa)',
    descripcion: 'Enzima hepática AST',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  {
    id: '14',
    nombre: 'FA (Fosfatasa Alcalina)',
    descripcion: 'Enzima fosfatasa alcalina',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  {
    id: '15',
    nombre: 'Proteínas Totales',
    descripcion: 'Medición de proteínas totales en suero',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  {
    id: '16',
    nombre: 'Colesterol',
    descripcion: 'Medición de colesterol total',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 12 horas',
    urgente: false
  },
  {
    id: '17',
    nombre: 'Triglicéridos',
    descripcion: 'Medición de triglicéridos',
    precio: 115,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 12 horas',
    urgente: false
  },
  {
    id: '18',
    nombre: 'Paquete 3 Analitos',
    descripcion: 'Selecciona 3 analitos bioquímicos',
    precio: 295,
    tiempoEntrega: 'Mismo día',
    categoria: 'Bioquímica',
    preparacion: 'Ayuno de 8 horas',
    urgente: false
  },
  
  // ELECTROLITOS
  {
    id: '19',
    nombre: 'Electrolitos (Na, K, Cl)',
    descripcion: 'Medición de Sodio, Potasio y Cloro',
    precio: 175,
    tiempoEntrega: 'Mismo día',
    categoria: 'Electrolitos',
    preparacion: 'No requiere ayuno',
    urgente: true,
    precioUrgente: 295
  },
  
  // ORINA
  {
    id: '20',
    nombre: 'Urianálisis Completo',
    descripcion: 'Análisis físico, químico y sedimento urinario',
    precio: 135,
    tiempoEntrega: 'Mismo día',
    categoria: 'Orina',
    preparacion: 'Muestra de primera orina del día',
    urgente: true,
    precioUrgente: 215
  },
  
  // PARASITOLOGÍA
  {
    id: '21',
    nombre: 'Flotación',
    descripcion: 'Búsqueda de parásitos intestinales por flotación',
    precio: 135,
    tiempoEntrega: 'Mismo día',
    categoria: 'Parasitología',
    preparacion: 'Muestra reciente',
    urgente: true,
    precioUrgente: 195
  },
  {
    id: '22',
    nombre: 'Faust',
    descripcion: 'Método de Faust para detección de parásitos',
    precio: 135,
    tiempoEntrega: 'Mismo día',
    categoria: 'Parasitología',
    preparacion: 'Muestra reciente',
    urgente: false
  },
  {
    id: '23',
    nombre: 'Flotación + Faust',
    descripcion: 'Combinación de ambos métodos parasitológicos',
    precio: 175,
    tiempoEntrega: 'Mismo día',
    categoria: 'Parasitología',
    preparacion: 'Muestra reciente',
    urgente: false
  },
  {
    id: '24',
    nombre: 'Coprológico Seriado',
    descripcion: 'Análisis de 3 muestras seriadas',
    precio: 315,
    tiempoEntrega: '3 días',
    categoria: 'Parasitología',
    preparacion: '3 muestras en días diferentes',
    urgente: false
  },
  {
    id: '25',
    nombre: 'Kinyoun',
    descripcion: 'Tinción de Kinyoun para detección de coccidios',
    precio: 155,
    tiempoEntrega: 'Mismo día',
    categoria: 'Parasitología',
    preparacion: 'Muestra reciente',
    urgente: false
  },
  {
    id: '26',
    nombre: 'Raspado de Piel',
    descripcion: 'Búsqueda de ectoparásitos y hongos',
    precio: 155,
    tiempoEntrega: 'Mismo día',
    categoria: 'Parasitología',
    preparacion: 'No bañar 48 horas antes',
    urgente: false
  },
  
  // PAQUETES
  {
    id: '27',
    nombre: 'Check Básico',
    descripcion: 'Hemograma + Perfil básico',
    precio: 545,
    tiempoEntrega: 'Mismo día',
    categoria: 'Paquetes',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: true,
    precioUrgente: 795
  },
  {
    id: '28',
    nombre: 'Check Completo',
    descripcion: 'Hemograma + Perfil completo',
    precio: 695,
    tiempoEntrega: 'Mismo día',
    categoria: 'Paquetes',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: true,
    precioUrgente: 1045
  },
  {
    id: '29',
    nombre: 'Prequirúrgico',
    descripcion: 'Hemograma + Perfil prequirúrgico',
    precio: 475,
    tiempoEntrega: 'Mismo día',
    categoria: 'Paquetes',
    preparacion: 'Ayuno de 8-12 horas',
    urgente: true,
    precioUrgente: 695
  },
  {
    id: '30',
    nombre: 'Renal Completo',
    descripcion: 'Perfil renal + Urianálisis',
    precio: 515,
    tiempoEntrega: 'Mismo día',
    categoria: 'Paquetes',
    preparacion: 'Ayuno de 8-12 horas y muestra de orina',
    urgente: false
  }
];

export const sucursales = [
  {
    id: '1',
    nombre: 'MoraBioVet - Matriz',
    direccion: 'Cenzontle 137, Palo Solo, 52778 Naucalpan de Juárez, Estado de México',
    telefono: '554-554-7772',
    whatsapp: '5215545547772',
    horario: 'Lunes a Viernes: 8:00 AM - 7:00 PM, Sábados: 9:00 AM - 2:00 PM',
    lat: 19.4139435,
    lng: -99.2690990,
    servicios: ['Toma de muestras', 'Entrega de resultados', 'Consultas']
  }
];

export const promociones = [
  {
    id: '1',
    titulo: 'Descuentos por Inauguración',
    subtitulo: 'Contáctanos',
    descripcion: 'Estamos celebrando nuestra inauguración con descuentos especiales',
    descuento: 0,
    validoHasta: '2026-12-31',
    imagen: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=800&q=80'
  },
  {
    id: '2',
    titulo: 'Promoción Check-up Anual',
    subtitulo: 'Paquetes especiales',
    descripcion: 'Aprovecha nuestros paquetes de chequeo preventivo',
    descuento: 0,
    validoHasta: '2026-12-31',
    imagen: 'https://images.unsplash.com/photo-1548681528-6a5c45b66b42?w=800&q=80'
  },
  {
    id: '3',
    titulo: 'Meses sin intereses',
    subtitulo: 'Hasta 3 MSI',
    descripcion: 'En compras mayores a $1,500 pesos',
    descuento: 0,
    validoHasta: '2026-12-31',
    imagen: 'https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?w=800&q=80'
  }
];

export const blogPosts = [
  {
    id: '1',
    titulo: 'Chequeo Preventivo en Mascotas: Detectar a tiempo puede salvar su vida',
    resumen: 'En MoraBioVet creemos en algo fundamental: Las enfermedades no comienzan cuando aparecen los síntomas, comienzan mucho antes.',
    contenido: `
# 🐾 Chequeo Preventivo en Mascotas
## Detectar a tiempo puede salvar su vida

En MorabioVet creemos en algo fundamental:
👉 **Las enfermedades no comienzan cuando aparecen los síntomas, comienzan mucho antes.**

La medicina veterinaria moderna ha demostrado que la mayoría de las enfermedades en perros y gatos se desarrollan de forma silenciosa, sin señales visibles para el dueño.

## 🔬 ¿Por qué hacer estudios antes de que tu mascota se vea enferma?

Muchos padecimientos son **subclínicos**, es decir, no presentan síntomas en etapas tempranas.

> "La detección temprana permite identificar problemas al inicio, cuando son más fáciles de tratar."
> — Banfield Pet Hospital (Medicina preventiva veterinaria)

Especialmente en gatos, los signos pueden ocultarse hasta etapas avanzadas.

👉 **Esto significa que cuando notas algo, la enfermedad ya puede estar avanzada.**

## 🧪 ¿Qué detecta un chequeo preventivo?

Un perfil preventivo puede identificar alteraciones incluso cuando tu mascota parece sana.

De acuerdo con la Universidad Nacional Autónoma de México:

> "Los estudios clínicos ayudan a detectar fallas o anormalidades a tiempo… lo que podría salvar la vida del animal."
> — Ciencia UNAM

### Con estudios de laboratorio puedes detectar:
- Enfermedad renal en etapa temprana
- Diabetes antes de síntomas
- Problemas hepáticos silenciosos
- Infecciones ocultas
- Parásitos intestinales
- Desequilibrios metabólicos

## ❤️ Medicina preventiva = más años y mejor calidad de vida

Según el MSD Veterinary Manual:

> "Los exámenes preventivos tienen como objetivo la vigilancia de la salud y la planificación del bienestar."

### 👉 Detectar a tiempo permite:
- Tratamientos más simples
- Menores costos médicos
- Menos sufrimiento para tu mascota
- Mayor esperanza de vida

## 🧠 Tu mascota envejece más rápido que tú

> "Las mascotas envejecen entre 6 y 10 años por cada año humano."
> — Banfield Pet Hospital

Esto significa que un año sin revisión puede equivaler a muchos años de enfermedad no detectada.

## ⚠️ El error más común

Muchas personas solo acuden al veterinario cuando su mascota ya está enferma.

### Esto provoca:
- Diagnósticos tardíos
- Tratamientos más costosos
- Enfermedades avanzadas
- Menor probabilidad de recuperación

👉 **En medicina veterinaria, prevenir siempre será mejor que tratar.**

## 🧾 ¿Cada cuánto hacer un chequeo?

Recomendación basada en guías veterinarias internacionales:

- 🐶 **Cachorros:** cada 3–4 semanas
- 🐕 **Adultos:** 1 vez al año
- 🐾 **Mayores:** cada 6 meses

## 🧪 Chequeos preventivos en MorabioVet

En MorabioVet Laboratorio Veterinario ofrecemos estudios diseñados para detectar enfermedades antes de que se manifiesten:

✔ Perfiles preventivos completos
✔ Check up anual
✔ Panel geriátrico
✔ Estudios de rutina y seguimiento

👉 **Nuestro objetivo no es solo diagnosticar enfermedades…**
👉 **Es evitarlas o detectarlas a tiempo.**

## 🐾 Mensaje importante

Tu mascota no puede decirte que algo está mal.
Pero su cuerpo sí lo muestra… antes de que tú lo notes.

👉 **Un chequeo hoy puede significar años más de vida mañana.**

## 📚 Fuentes científicas y médicas
- Ciencia UNAM – Cuidado de animales de compañía
- MSD Veterinary Manual – Preventive Healthcare
- Banfield Pet Hospital – Medicina preventiva veterinaria
- WSAVA (World Small Animal Veterinary Association) – Guías de bienestar animal

## 📞 Agenda su chequeo preventivo

No esperes a que haya síntomas.

👉 **Agenda hoy y dale a tu mascota la oportunidad de una vida más larga y saludable.**
    `,
    fecha: '2026-03-23',
    autor: 'Dr. Carlos Mora',
    imagen: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=800&q=80',
    categoria: 'Prevención'
  },
  {
    id: '2',
    titulo: '¿Cómo interpretar un hemograma en mascotas?',
    resumen: 'Guía básica para entender los resultados de tu perro o gato',
    contenido: `
# 🧪 ¿Cómo interpretar un hemograma en mascotas?
## Guía básica para entender los resultados de tu perro o gato

El hemograma es uno de los estudios más importantes en medicina veterinaria.
Permite evaluar el estado general de salud y detectar enfermedades incluso antes de que haya síntomas.

👉 **En MorabioVet Laboratorio Veterinario utilizamos el hemograma como herramienta clave de diagnóstico y prevención.**

## 🔬 ¿Qué es un hemograma?

Es un análisis de sangre que evalúa tres componentes principales:

- Glóbulos rojos (eritrocitos)
- Glóbulos blancos (leucocitos)
- Plaquetas

Según el MSD Veterinary Manual:

> "El hemograma proporciona información esencial sobre el estado de salud general y ayuda a identificar infecciones, inflamación, anemia y otros trastornos."

## 🩸 1. Glóbulos rojos (Eritrocitos)

**👉 Transportan oxígeno en el cuerpo**

### Parámetros importantes:
- Hematocrito (HCT)
- Hemoglobina (HGB)
- Recuento de eritrocitos

### Interpretación:

**🔻 Valores bajos:**
- Anemia
- Pérdida de sangre
- Enfermedad crónica

**🔺 Valores altos:**
- Deshidratación
- Problemas respiratorios

📌 De acuerdo con la Universidad Nacional Autónoma de México:

> "Alteraciones en los eritrocitos pueden indicar problemas sistémicos importantes como anemia o deshidratación."

## ⚪ 2. Glóbulos blancos (Leucocitos)

**👉 Defienden contra infecciones**

### Tipos principales:
- Neutrófilos
- Linfocitos
- Monocitos
- Eosinófilos
- Basófilos

### Interpretación:

**🔺 Leucocitos altos:**
- Infección bacteriana
- Inflamación
- Estrés

**🔻 Leucocitos bajos:**
- Infecciones virales
- Problemas en médula ósea

Según el World Small Animal Veterinary Association:

> "Los cambios en el recuento leucocitario son fundamentales para identificar procesos infecciosos o inflamatorios."

## 🟡 3. Plaquetas

**👉 Participan en la coagulación**

### Interpretación:

**🔻 Plaquetas bajas:**
- Riesgo de hemorragias
- Enfermedades infecciosas (ej. ehrlichia)

**🔺 Plaquetas altas:**
- Procesos inflamatorios
- Respuesta a enfermedad

El MSD Veterinary Manual señala:

> "Las alteraciones plaquetarias pueden indicar trastornos de coagulación o enfermedades sistémicas."

## 📊 4. ¿Qué significan los valores fuera de rango?

### ⚠️ IMPORTANTE:
Un resultado fuera de rango no siempre significa enfermedad grave.

Puede deberse a:
- Estrés del animal
- Deshidratación
- Edad
- Medicamentos
- Variaciones normales

👉 **Por eso, los resultados siempre deben ser interpretados por un médico veterinario.**

## 🧠 5. Interpretación integral (lo más importante)

Un hemograma no se interpreta por un solo valor, sino por el conjunto de resultados.

**Ejemplo:**
- Anemia + leucocitos altos → posible infección
- Plaquetas bajas + fiebre → posible enfermedad transmitida por garrapatas

### 👉 La clave está en correlacionar:
- Resultados de laboratorio
- Signos clínicos
- Historia del paciente

## 🧪 6. ¿Por qué hacer hemogramas aunque tu mascota esté sana?

Porque muchas enfermedades comienzan sin síntomas.

> "La detección temprana depende de identificar anormalidades en animales aparentemente sanos."
> — Medicina preventiva veterinaria

### 👉 Un hemograma puede detectar:
- Enfermedades en etapa inicial
- Infecciones ocultas
- Problemas inmunológicos
- Alteraciones antes de síntomas visibles

## 🐾 En MorabioVet te ayudamos a entender los resultados

En MorabioVet Laboratorio Veterinario no solo realizamos estudios, también te ayudamos a interpretarlos correctamente.

✔ Resultados claros
✔ Asesoría profesional
✔ Enfoque preventivo

## ⚠️ Mensaje importante

Interpretar un hemograma por cuenta propia puede llevar a errores.

👉 **Un solo valor no define un diagnóstico.**
👉 **El contexto clínico lo es todo.**

## 📚 Fuentes confiables
- MSD Veterinary Manual – Hematología veterinaria
- Universidad Nacional Autónoma de México (UNAM)
- WSAVA – Guías clínicas internacionales
- Literatura de medicina veterinaria preventiva

## 📞 ¿Necesitas interpretar los resultados de tu mascota?

Envíanos tus estudios o agenda un chequeo.

👉 **Detectar a tiempo puede hacer toda la diferencia.**
    `,
    fecha: '2026-03-20',
    autor: 'Dra. María González',
    imagen: 'https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?w=800&q=80',
    categoria: 'Educación'
  },
  {
    id: '3',
    titulo: 'Cuidados pre-analíticos: preparación para estudios',
    resumen: 'Cómo preparar a tu mascota antes de tomar muestras de laboratorio',
    contenido: `
# 🐾 Cuidados pre-analíticos: preparación para estudios
## Cómo preparar a tu mascota antes de tomar muestras de laboratorio

Los resultados de laboratorio no solo dependen del equipo o del análisis…
👉 **también dependen de cómo se prepara tu mascota antes de la toma de muestra.**

A esto se le conoce como fase pre-analítica, y es una de las más importantes para obtener resultados confiables.

## 🔬 ¿Qué son los cuidados pre-analíticos?

Son todas las medidas que se toman antes del estudio de laboratorio, como:

- Ayuno
- Manejo del estrés
- Medicación previa
- Hidratación
- Horario de toma de muestra

Según el MSD Veterinary Manual:

> "La fase preanalítica es una de las principales fuentes de variación en los resultados de laboratorio."

👉 **Esto significa que una mala preparación puede alterar los resultados, incluso si el análisis está bien realizado.**

## 🧪 1. Ayuno: uno de los factores más importantes

✅ **Recomendación general:**
Perros y gatos: 8 a 12 horas de ayuno

### ¿Por qué es importante?

Después de comer, la sangre cambia (lipemia), lo que puede afectar resultados como:

- Glucosa
- Triglicéridos
- Enzimas hepáticas

> "El ayuno es esencial para evitar interferencias en pruebas bioquímicas."
> — Guías de laboratorio clínico veterinario

### ⚠️ IMPORTANTE:
El agua sí está permitida, a menos que el veterinario indique lo contrario.

## 💊 2. Medicamentos: no siempre deben suspenderse

Algunos medicamentos pueden alterar resultados, por ejemplo:

- Corticoides
- Antibióticos
- Antiinflamatorios

👉 **Pero nunca debes suspenderlos sin indicación veterinaria.**

En muchos casos, el médico:
- Ajusta la interpretación
- O programa el estudio en otro momento

## 🐾 3. Evitar el estrés antes del estudio

El estrés puede alterar varios parámetros, especialmente:

- Glucosa
- Leucocitos (glóbulos blancos)
- Hormonas

Según la World Small Animal Veterinary Association:

> "El estrés puede provocar cambios fisiológicos que afectan los resultados clínicos."

### 👉 Tips:
- Evita ejercicio intenso antes del estudio
- Mantén a tu mascota tranquila
- Llévala con tiempo para que se adapte al entorno

## 💧 4. Hidratación adecuada

Una mascota deshidratada puede presentar:

- Hemoconcentración (valores falsamente elevados)
- Alteraciones en electrolitos

👉 **Asegúrate de que tenga acceso a agua antes del estudio (si no hay restricción).**

## 🕒 5. Horario de la toma de muestra

Algunas sustancias cambian durante el día (ritmos biológicos).

Por eso, muchos estudios se recomiendan:
- Por la mañana
- En ayuno

👉 **Esto permite resultados más estandarizados y comparables.**

## 🐶 6. Para muestras específicas

### 🩸 Sangre
- Ayuno previo
- Evitar estrés
- No ejercicio intenso

### 💩 Heces
- Muestra fresca (máximo 2–4 horas)
- Evitar contaminación con tierra o químicos

### 🧴 Orina
- Preferible primera orina del día
- Recipiente limpio
- Entregar lo antes posible

## ⚠️ 7. Errores comunes que debes evitar

❌ Dar comida antes del estudio
❌ No informar sobre medicamentos
❌ Llevar a la mascota después de ejercicio intenso
❌ Muestras mal almacenadas
❌ Retrasar la entrega de muestras

👉 **Estos errores pueden provocar resultados incorrectos o repetir estudios.**

## 🧠 ¿Por qué es tan importante todo esto?

Porque:

> "Las variaciones preanalíticas pueden llevar a interpretaciones erróneas y decisiones clínicas incorrectas."
> — MSD Veterinary Manual

### 👉 En pocas palabras:
**Un mal preparado puede parecer una enfermedad… o esconder una real.**

## 🧪 En MorabioVet Laboratorio Veterinario te orientamos

Nuestro equipo te guía en cada paso para asegurar resultados confiables:

✔ Indicaciones claras antes del estudio
✔ Acompañamiento en la toma de muestra
✔ Interpretación profesional

## 🐾 Mensaje importante

Preparar bien a tu mascota no es opcional…
👉 **Es parte del estudio.**

**Un buen resultado comienza antes de tomar la muestra.**

## 📚 Fuentes confiables
- MSD Veterinary Manual – Fase preanalítica
- WSAVA – Guías clínicas y bienestar animal
- Literatura de laboratorio clínico veterinario

## 📞 ¿Tienes dudas antes del estudio?

Contáctanos y te orientamos paso a paso.

👉 **En MorabioVet, la precisión comienza desde la preparación.**
    `,
    fecha: '2026-03-15',
    autor: 'MVZ. Ana Ramírez',
    imagen: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=800&q=80',
    categoria: 'Consejos'
  }
];

export const resultadosMock = [
  {
    id: '1',
    paciente: 'Max',
    estudio: 'Hemograma Completo',
    fecha: '2026-03-18',
    estado: 'Disponible',
    pdfUrl: '/resultados/ejemplo.pdf'
  },
  {
    id: '2',
    paciente: 'Luna',
    estudio: 'Perfil Bioquímico',
    fecha: '2026-03-15',
    estado: 'Disponible',
    pdfUrl: '/resultados/ejemplo.pdf'
  },
  {
    id: '3',
    paciente: 'Rocky',
    estudio: 'Urianálisis',
    fecha: '2026-03-10',
    estado: 'Disponible',
    pdfUrl: '/resultados/ejemplo.pdf'
  }
];

export const usuarioMock = {
  nombre: 'Juan Pérez',
  email: 'juan.perez@example.com',
  telefono: '555-987-6543',
  mascotas: [
    { id: '1', nombre: 'Max', especie: 'Canino', raza: 'Labrador', edad: 5 },
    { id: '2', nombre: 'Luna', especie: 'Felino', raza: 'Siamés', edad: 3 }
  ]
};
